import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["trigger", "dialog"];

    open(event) {
        if (!this.hasDialogTarget || typeof this.dialogTarget.showModal !== "function") {
            return;
        }

        event.preventDefault();
        this.activeTrigger = event.currentTarget;
        this.dialogTarget.showModal();
    }

    close() {
        if (this.hasDialogTarget && this.dialogTarget.open) {
            this.dialogTarget.close();
        }
    }

    closeFromBackdrop(event) {
        if (event.target !== this.dialogTarget) {
            return;
        }

        const bounds = this.dialogTarget.getBoundingClientRect();
        const isInside =
            event.clientX >= bounds.left &&
            event.clientX <= bounds.right &&
            event.clientY >= bounds.top &&
            event.clientY <= bounds.bottom;

        if (!isInside) {
            this.close();
        }
    }

    restoreFocus() {
        if (this.activeTrigger?.isConnected) {
            this.activeTrigger.focus();
        }

        this.activeTrigger = null;
    }
}
